import { getLoginUrl } from "@/lib/utils/routing";
import { Anchor, Box, Button, Stack, Text, Title } from "@mantine/core";
import WorkspacePremiumRounded from "@mui/icons-material/WorkspacePremiumRounded";
import clsx from "clsx";
import { useSession } from "next-auth/react";
import Link from "next/link";
import NoAccessIcon from "../../../public/static/images/permissions/noaccessicon.svg";
import classes from "./NoAccess.module.css";

export default function NoAccess() {
  const { data: session } = useSession();
  const status =
    session?.user.subscriptionMeta?.status === "trialing"
      ? "trial"
      : "membership";
  return (
    <Stack className={classes.wrapper}>
      <Title order={2} className={classes.title}>
        Sail through the IB!
      </Title>
      <Box className={classes.imgWrapper} mx={"auto"}>
        <NoAccessIcon />
      </Box>
      {session?.user ? (
        <>
          <Text className={classes.text}>
            Your{" "}
            <span className={classes.highlight}>
              {status} does not include access
            </span>{" "}
            to these IB resources!
          </Text>
          <Text className={classes.text}>
            Upgrade to a {status === "trial" ? "full" : "new"} membership and{" "}
            <span className={clsx(classes.highlight, classes.highlight2)}>
              unlock the full power
            </span>{" "}
            of Tiber Tutor&apos;s: videos, notes, flashcards, definitions, cram
            sheets, questions and tests!
          </Text>
          <Button
            className={classes.button}
            component={Link}
            href={"/profile/membership"}
            color="gold"
            size="md"
            leftSection={<WorkspacePremiumRounded />}
          >
            Upgrade
          </Button>
        </>
      ) : (
        <>
          <Text className={classes.text}>
            Only our members can access these IB resources. Redeem a{" "}
            <span className={classes.highlight}>
              free 7 day trial, or upgrade to a full membership
            </span>{" "}
            to unlock the full power of Tiber Tutor!
          </Text>
          <Text className={classes.text}>
            You&apos;ll be{" "}
            <span className={clsx(classes.highlight, classes.highlight2)}>
              sailing through the IB
            </span>{" "}
            in no time.
          </Text>
          <Button
            className={classes.button}
            component={Link}
            href={"/pricing"}
            color="darkblue"
            size="md"
            leftSection={<WorkspacePremiumRounded />}
          >
            View Memberships
          </Button>
          <Text ta="center" c="dimmed">
            Already with us?{" "}
            <Anchor
              href="/login"
              onClick={(event) => {
                event.preventDefault();
                if (typeof window !== "undefined") {
                  window.location.href = getLoginUrl();
                }
              }}
              aria-label="Login"
            >
              Login
            </Anchor>
          </Text>
        </>
      )}
    </Stack>
  );
}

export const useAccessBannerStyles = () => ({ classes });
